import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant22() {
  const {
    language
  } = useLanguage();
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const content = {
    ru: {
      strike: 'Обычно от $1000',
      title: 'Не платите за создание сайта.',
      sub: `Мы бесплатно разработаем дизайн и запустим сайт. Вы платите только фиксированную подписку ${price}/мес за то, чтобы он работал и приносил клиентов.`,
      cta: 'Начать бесплатно',
      note: 'Сначала макет — потом оплата.'
    },
    ua: {
      strike: 'Зазвичай від $1000',
      title: 'Не платіть за створення сайту.',
      sub: `Ми безкоштовно розробимо дизайн та запустимо сайт. Ви платите лише фіксовану підписку ${price}/міс за те, щоб він працював і приносив клієнтів.`,
      cta: 'Почати безкоштовно',
      note: 'Спочатку макет — потім оплата.'
    },
    en: {
      strike: 'Usually from $1000',
      title: "Don't pay for website creation.",
      sub: `We will design and launch your website for free. You only pay a fixed subscription of ${price}/mo to keep it running and bringing in clients.`,
      cta: 'Start for free',
      note: 'Mockup first — pay later.'
    }
  }[language] || content.ru;
  return <>
      <section className="relative min-h-screen w-full overflow-hidden pt-32 pb-20 flex items-center" style={{
      backgroundColor: 'var(--bg-primary)'
    }} data-id="element-486">
        <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col lg:flex-row items-center justify-between gap-12 px-4" data-id="element-487">
          {/* Left Column - Pain Point Focus */}
          <div className="w-full lg:w-1/2 text-left flex flex-col items-start" data-id="element-488">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} className="inline-flex items-center gap-3 px-4 py-2 rounded-xl bg-red-50 border border-red-100 mb-6" data-id="element-489">
              <span className="text-red-400 line-through font-bold" data-id="element-490">
                {content.strike}
              </span>
              <span className="text-green-600 font-black" data-id="element-491">У нас — 0$</span>
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="mb-6 text-4xl md:text-5xl lg:text-6xl font-black leading-tight tracking-tight text-gray-900" data-id="element-492">
              {content.title}
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="text-lg md:text-xl mb-8 text-gray-600 font-medium max-w-lg leading-relaxed" data-id="element-493">
              {content.sub}
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} className="flex flex-col items-start gap-4 w-full sm:w-auto" data-id="element-494">
              <button onClick={() => setIsPopupOpen(true)} className="group flex items-center justify-center gap-2 rounded-xl px-8 py-4 font-bold text-lg transition-all hover:scale-105 w-full sm:w-auto" style={{
              backgroundColor: 'var(--text-primary)',
              color: '#FFFFFF'
            }} data-id="element-495">
                {content.cta}
                <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-496" />
              </button>
              <span className="text-sm font-medium text-gray-500 ml-2" data-id="element-497">
                {content.note}
              </span>
            </motion.div>
          </div>

          {/* Right Column - Clean Video */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 relative mt-12 lg:mt-0" data-id="element-498">
            <div className="relative w-full max-w-2xl mx-auto rounded-2xl overflow-hidden shadow-xl border border-gray-200" data-id="element-499">
              <video src="https://cdn.magicpatterns.com/uploads/vrXe21wkVqS62d5BzpZ9eJ/original-2de319f4767c5a0d4acf4f107b938504.mp4" autoPlay loop muted playsInline className="w-full h-auto" data-id="element-500" />
            </div>
          </motion.div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-501" />
    </>;
}